<template >
  <div>
    <div v-if="getStatusUpdateConfirmation().status && calledIn == 'txnDetail'&&!showCancel">
      <!-- <label for="">Confirmation</label> -->
      <p style="margin:0 0 10px 0">
        {{getStatusUpdateConfirmation().message }}
        <b>{{getStatusUpdateConfirmation().txnStatusToBeUpdated}}</b>?
      </p>
      <button
        type="button"
        class="btn btn-sm btn-success"
        @click.stop="updateTransaction(txn, getStatusUpdateConfirmation().txnStatusToBeUpdated)"
        name="update"
      >Update</button>
      <button
        type="button"
        class="btn btn-sm btn-danger"
        @click.stop="resetTxn()"
        name="cancel"
      >Cancel</button>
    </div>
    <div v-else>
      <template v-if="calledIn!=='txnDetail'">
        <b-dropdown
          v-if="txnStatusCombinations[txn.status].length && user.role==='MARKETPLACE_RW'"
          variant="getVariant(txn.status)"
          :id="'ddown-'+txn.status"
          size="sm"
          :text="txnStatusEnum[txn.status].name.toUpperCase()"
          class="m-2 btn-default"
        >
          <template v-for="status in txnStatusCombinations[txn.status]">
            <b-dropdown-item
              v-if="status.value != 'partially_returned' && status.value != 'partial_refunded'&&status.value!=='partially_settled'&&status.value!=='delivered'"
              :key="status.value"
              @click.stop="confirmStatusUpdate(txn, status.value)"
            >{{status.name.toUpperCase()}}</b-dropdown-item>
            <b-dropdown-item
              v-if="status.value == 'partially_returned' || status.value == 'partial_refunded'||status.value==='partially_settled'||status.value==='delivered'"
              :key="status.value"
              @click.stop="updateTransactionWithAmount(txn, status.value, calledIn)"
            >{{status.name.toUpperCase()}}</b-dropdown-item>
          </template>
        </b-dropdown>
        <div v-else class="m-2">
          <button
            disabled
            class="btn-xs btn btn-default"
            :class="[
                                                                    { 'btn-warning':( txn.status.toUpperCase() == 'AGREED' ||  txn.status.toUpperCase() == 'PARTIAL REFUND') },
                                                                    { 'btn-warning':( txn.status.toUpperCase() == 'REFUNDED' ||  txn.status.toUpperCase() == 'RETURNED') },
                                                                    { 'btn-info':( txn.status.toUpperCase() == 'CONFIRMED' ||  txn.status.toUpperCase() == 'CONFIRMED_UPDATE') },
                                                                    { 'btn-danger': (txn.status.toUpperCase() == 'CANCELLED') }]"
          >{{txnStatusEnum[txn.status].name.toUpperCase()}}</button>
        </div>
        <div v-if="txnUpdate.error && calledIn == 'txnDetail'" class="alert alert-danger">
          <p style="margin:0">{{txnUpdate.error}}</p>
        </div>
      </template>
      <form
        @submit.prevent="txn.status==='confirmed'?updateInvoiceData(txn):updateTransaction(getCurrentTxnStatus('txn'), getCurrentTxnStatus('status'), true)"
        @click.stop="stopBubble"
        v-if="getTxnUpdateForm() && calledIn=='txnDetail'&&!showCancel"
      >
        <div class="form-group">
          <template v-if="txn.status!=='confirmed'">
            <label for="returnAmount">Return Amount (in Rupees)</label>
            <div class="input-group mb-3">
              <input
                type="number"
                class="form-control form-control-sm"
                step=".01"
                min="1"
                v-bind:max="txn.txnAmount - 0.01"
                name="returnAmount"
                value="0.00"
                v-model="returnAmount"
              >
            </div>
            <div>
              <button
                type="submit"
                class="btn btn-sm btn-success"
                variant="success"
                name="update"
              >Update</button>
              <button
                type="button"
                class="btn btn-sm btn-danger"
                @click.stop="resetTxn()"
                name="cancel"
              >Cancel</button>
            </div>
          </template>
          <template v-if="txn.status==='confirmed'">
            <label for="returnAmount">Invoice Amount (in Rupees)</label>
            <div class="input-group mb-3">
              <input
                type="number"
                class="form-control form-control-sm"
                step=".01"
                min="1"
                v-bind:max="txn.txnAmount"
                name="invoiceAmount"
                value="0.00"
                v-model="invoice.amount"
              >
            </div>
            <label for="returnAmount">Invoice Number</label>
            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control form-control-sm"
                name="returnAmount"
                value="0.00"
                v-model="invoice.invoiceNumber"
              >
            </div>
            <div>
              <button
                type="submit"
                class="btn btn-sm btn-success"
                variant="success"
                name="update"
              >Update</button>
              <button
                type="button"
                class="btn btn-sm btn-danger"
                @click.stop="resetTxn()"
                name="cancel"
              >Cancel</button>
            </div>
          </template>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TxnStatusUpdateDD",
  props: [
    "txn",
    "txnStatusEnum",
    "calledIn",
    "setTxn",
    "getTxnUpdateForm",
    "setTxnUpdateForm",
    "getCurrentTxnStatus",
    "setCurrentTxnStatus",
    "resetTxn",
    "getStatusUpdateConfirmation",
    "toggleConfirmationBox",
    "showCancel"
  ],
  data() {
    return {
      returnAmount: 0,
      invoice: {
        amount: 0,
        invoiceNumber: ""
      },
      txnUpdate: {
        error: undefined
      },
      txnStatusCombinations: {
        confirmed: [
          {
            name: "Cancelled",
            value: "cancelled"
          },
          {
            name: "Delivered",
            value: "delivered"
          }
        ],
        delivered: [
          {
            name: "Partial Return",
            value: "partially_returned"
          },
          {
            name: "Full Return",
            value: "returned"
          }
        ],
        returned: [
          // {
          //   name:'Partial Return',
          //   value:'partially_returned'
          // },
          // {
          //   name:'Full Return',
          //   value:'returned'
          // }
        ],
        settled: [
          {
            name: "Partial Refund",
            value: "partial_refunded"
          },
          {
            name: "Full Refund",
            value: "refunded"
          }
        ],
        deconstructed: [],
        settled_final: [
          {
            name: "Partial Refund",
            value: "partial_refunded"
          },
          {
            name: "Full Refund",
            value: "refunded"
          }
        ],
        refunded: [],
        partial_refund_pending: [],
        cancelled: [],
        refund_pending: [],
        partial_refunded: [
          {
            name: "Partial Refund",
            value: "partial_refunded"
          },
          {
            name: "Full Refund",
            value: "refunded"
          }
        ],
        partially_returned: [
          {
            name: "Partial Return",
            value: "partially_returned"
          },
          {
            name: "Full Return",
            value: "returned"
          }
        ],
        partially_settled: [
          {
            name: "Partial Return",
            value: "partially_returned"
          },
          {
            name: "Full Return",
            value: "returned"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["user"])
  },
  watch: {
    returnAmount: function(newVal) {
      var currentTxnStatus = this.getCurrentTxnStatus();
      currentTxnStatus.returnAmount = newVal;
      this.setCurrentTxnStatus(currentTxnStatus);
    }
  },
  filters: {
    removeUnderscores: function(value) {
      if (!value) return "";
      return value.replace(/_/g, " ");
    }
  },
  methods: {
    getVariant(status) {
      status = status.toUpperCase();
      switch (status) {
        case "DELIVERED":
          return "success";
          break;
        case "CONFIRMED":
        case "CONFIRMED_UPDATE":
          return "info";
          break;
        case "CANCELLED":
          return "danger";
          break;
        default:
          return "default";
      }
    },
    updateStatus(response, txn) {
      if (response.data.failure == 1) {
        this.txnUpdate.error = response.data.failureReport[0].reason;
      } else {
        txn.status = response.data.status;
        txn.txnAmount = response.data.amount / 100;
        this.resetTxn();
      }
    },
    updateStatusError(err) {
      if (err.status != 401) {
        this.txnUpdate.error = err.data.message;
        if (err.errors) {
          this.txnUpdate.error = err.errors[0];
        }
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    clearModal() {
      this.txnUpdate.error = undefined;
      let currentTxnStatus = this.getCurrentTxnStatus();
      currentTxnStatus.refundAmt = 0;
      this.setCurrentTxnStatus(currentTxnStatus);
    },
    confirmStatusUpdate(txn, status, withAmount) {
      this.setTxn(txn);
      if (!withAmount) {
        this.toggleConfirmationBox(true, status);
      }
    },
    updateInvoiceData(txn) {
      const query = JSON.parse(JSON.stringify(this.invoice));
      query.amount === ""
        ? (query.amount = parseFloat(txn.txnAmount) * 100).toFixed(2)
        : (query.amount = parseFloat(query.amount) * 100).toFixed(2);
      this.$store
        .dispatch("deliveryUpdate", {
          sessionId: this.sessionId,
          txn_id: txn.marketplaceOrderId,
          query
        })
        .then(response => this.updateStatus(response, txn))
        .catch(err => this.updateStatusError(err));
    },
    updateTransaction(txn, status, withAmount) {
      if (status == "refunded" || status == "returned") {
        let query = {
          marketplaceOrderId: txn.marketplaceOrderId
            ? txn.marketplaceOrderId
            : txn.id,
          returnAmount: (txn.txnAmount * 100).toFixed(2),
          returnType: "full"
        };

        this.$store
          .dispatch("updateTransactionWithAmount", {
            sessionId: this.sessionId,
            txn_id: txn.id,
            query
          })
          .then(response => this.updateStatus(response, txn))
          .catch(err => this.updateStatusError(err));
      } else if (withAmount) {
        let query = {
          marketplaceOrderId: this.getCurrentTxnStatus("marketplaceOrderId")
            ? this.getCurrentTxnStatus("marketplaceOrderId")
            : this.getCurrentTxnStatus("txn").id,
          returnAmount: this.getCurrentTxnStatus("returnAmount") * 100, // Convert return amount from Rupees to to paise
          returnType: this.getCurrentTxnStatus("returnType")
        };

        this.$dialog
          .confirm(
            "Are you sure you want to mark a return for Rs. " +
              parseFloat(this.getCurrentTxnStatus("returnAmount")).toFixed(2) +
              "?",
            {
              loader: true
            }
          )
          .then(dialog => {
            this.$store
              .dispatch("updateTransactionWithAmount", {
                sessionId: this.sessionId,
                txn_id: txn.id,
                query
              })
              .then(response => {
                dialog.close();
                this.updateStatus(response, txn);
              })
              .catch(err => {
                dialog.close();
                this.updateStatusError(err);
              });
          })
          .catch(() => {});
      } else {
        let query = {
          txnIds: [txn.id],
          status: status
        };
        this.$store
          .dispatch("updateTransaction", { sessionId: this.sessionId, query })
          .then(response => {
            if (response.data.failure == 1) {
              this.txnUpdate.error = response.data.failureReport[0].reason;
            } else {
              txn.status = status;
              this.resetTxn();
            }
          })
          .catch(err => {
            if (err.status != 401) {
              this.txnUpdate.error = err.data.message;
            } else {
              this.$router.push({ name: "Login" });
            }
          });
      }
    },

    updateTransactionWithAmount(txn, status, calledIn = "txn") {
      let currentTxnStatus = {
        txn,
        status,
        marketplaceOrderId: txn.marketplaceOrderId,
        returnAmount: 0,
        returnType: "partial"
      };
      this.setCurrentTxnStatus(currentTxnStatus);
      if (calledIn == "txn") {
        // this.$refs.txnStatusModalRef.show()
        this.setTxn(txn);
        this.setTxnUpdateForm(true);
      } else {
        this.setTxnUpdateForm(true);
      }
      // this.$emit("showTxnStatusModal");
    }
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/TxnStatusUpdateDD.vue